import React from 'react';
import { Paperclip, Trash2 } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { AttachmentForm, AttachmentType } from '../../../types/transaction';
import { AttachmentFormSelect } from './AttachmentFormSelect';
import { AttachmentTypeSelect } from './AttachmentTypeSelect';
import { formatFileSize } from '../../../constants/attachments';

interface AttachmentRowProps {
  file: File;
  fileName: string;
  fileSize: number;
  form: AttachmentForm;
  type: AttachmentType;
  description: string;
  onFormChange: (value: AttachmentForm) => void;
  onTypeChange: (value: AttachmentType) => void;
  onDescriptionChange: (value: string) => void;
  onRemove: () => void;
  disabled?: boolean;
}

export function AttachmentRow({
  fileName,
  fileSize,
  form,
  type,
  description,
  onFormChange,
  onTypeChange,
  onDescriptionChange,
  onRemove,
  disabled = false,
}: AttachmentRowProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-[140px_1fr_160px_1fr_40px] gap-3 items-start p-3 bg-muted rounded-lg border border-border">
      {/* Form Selection */}
      <div className="flex flex-col">
        <label className="text-xs font-medium text-foreground mb-1.5 md:hidden">
          Forma do anexo
        </label>
        <AttachmentFormSelect
          value={form}
          onChange={onFormChange}
          disabled={disabled}
        />
      </div>

      {/* File Display */}
      <div className="flex flex-col">
        <label className="text-xs font-medium text-foreground mb-1.5 md:hidden">
          Anexo
        </label>
        <div className="flex items-center gap-2 px-3 py-2 bg-card border border-border rounded-md min-h-[40px]">
          <Paperclip className="h-4 w-4 text-muted-foreground flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground truncate">
              {fileName}
            </p>
            <p className="text-xs text-muted-foreground">
              {formatFileSize(fileSize)}
            </p>
          </div>
        </div>
      </div>

      {/* Type Selection */}
      <div className="flex flex-col">
        <label className="text-xs font-medium text-foreground mb-1.5 md:hidden">
          Tipo de anexo
        </label>
        <AttachmentTypeSelect
          value={type}
          onChange={onTypeChange}
          disabled={disabled}
        />
      </div>

      {/* Description Input */}
      <div className="flex flex-col">
        <label className="text-xs font-medium text-foreground mb-1.5 md:hidden">
          Descrição
        </label>
        <Input
          type="text"
          placeholder="Descrição do anexo..."
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          disabled={disabled}
          className="w-full"
        />
      </div>

      {/* Remove Button */}
      <div className="flex items-start md:items-center justify-center md:justify-start mt-0 md:mt-0">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onRemove}
          disabled={disabled}
          className="h-10 w-10 p-0 hover:bg-red-50 hover:text-red-600 transition-colors"
          title="Remover anexo"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
